import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationPopupComponent } from '../../../../shared/common/popups/confirmation-popup/confirmation-popup.component';
import { ApiCallsService } from '../../../../shared/services/network/api-calls.service';
import { SidebarService } from '../../../../shared/services/sidebar.service';
import { api } from '../../../../utils/endpoints';
import { SafeHtmlPipe } from '../../../../utils/pipes/safe-html.pipe';
import { confirmationMessages } from '../../../../utils/popup-messages';
import { ICONS } from '../../../../utils/svg-icons';

@Component({
  selector: 'app-agent-action',
  imports: [SafeHtmlPipe, NgbPopoverModule, NgbDropdownModule],
  templateUrl: './agent-action.html',
})
export class AgentAction {
  ICONS = ICONS;
  @Input() chatId: any;
  constructor(
    private readonly _ngbModal: NgbModal,
    private readonly _router: Router,
    private readonly _apiCalls: ApiCallsService,
    private readonly _toast: ToastrService,
    private readonly sidebarService: SidebarService,
  ) {}
  deleteSession(sessionId: any) {
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'small confirmationPopup',
    });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.deleteSesion;
    modalRef.result.then((res: any) => {
      if (res) {
        this._apiCalls.delete(`${api._deleteChat}/${sessionId}`, {}).subscribe({
          next: (res: any) => {
            this.sidebarService.requestDeleteSession(sessionId);
            this._router.navigate(['/agent/chat']);
            this._toast.success('Session has been deleted successfully');
          },
          error: (error: any) => {
            console.log(error);
          },
        });
      }
    });
  }
}
